<template>
  <el-form-item
    v-if="visible"
    :class="['sui-form-item', { colspan: colspan >= 1 }, `sui-form-item--${elMode}`, flex && 'sui-form-item-flex']"
    :style="{
      width: repairUnit(itemItemWidth)
    }"
    :prop="prop"
    :label="labelHide ? '' : _locale(label)"
    :label-width="itemLabelWidth"
    :size="elSize"
    :rules="itemRules"
  >
    <div v-if="item && $scopedSlots[item.prop + '_label']" slot="label" class="label_item">
      <slot :name="prop + '_label'"></slot>
    </div>
    <slot>
      <sui-prop v-if="item" ref="itemInput" :tag="_mold" :prop="itemProp" :events="itemProp.events" :tag-ref="itemProp.ref"></sui-prop>
    </slot>
    <slot name="label" slot="label"> </slot>
  </el-form-item>
</template>
<script>
import { parserValid } from '../../utils/valid.js'
import { getLocalStorage } from '../../utils/cache.js'
import { indexOf } from '../../utils/utils.js'
import { repairUnit } from '../../utils/style.js'
export default {
  name: 'SuiFormItem',
  inject: {
    SuiForm: {
      default: null
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    prop: {
      type: String,
      default: null
    },
    prompt: {
      type: String,
      default: null
    },
    itemWidth: {
      type: [String, Number],
      default: null
    },
    colspan: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    labelWidth: {
      type: [String, Number],
      default: null
    },
    labelHide: {
      type: Boolean,
      default: false
    },
    inputWidth: {
      type: [String, Number],
      default: null
    },
    required: {
      type: Boolean
    },
    rules: {
      type: [Object, Array],
      default: null
    },
    size: {
      type: String,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    mold: {
      type: String,
      default: 'input'
    },
    moldPrefix: {
      type: Array,
      default: () => ['sui-', 'el-']
    },
    flex: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      repairUnit,
      funcArr: ['blur', 'focus', 'change', 'clear']
    }
  },
  computed: {
    elMode() {
      return (this.$ELEMENT || {}).$mode || 'easy'
    },
    itemLabelWidth() {
      if (!this.label) {
        return null
      }
      let labelWidth = this.labelWidth || this.SuiForm.labelWidth
      return this.repairUnit(labelWidth)
    },
    itemItemWidth() {
      let itemWidth = this.itemWidth || this.SuiForm.itemWidth
      let labelWidth = this.labelWidth || this.SuiForm.labelWidth
      let inputWidth = this.inputWidth || this.SuiForm.inputWidth || ((this.$ELEMENT || {}).inputWidth || {})[this.elMode] || 230
      if (this.item) {
        inputWidth = this.item.width || this.item.inputWidth || inputWidth
      }
      if (itemWidth === 'auto' || (itemWidth && String(itemWidth).includes('%'))) {
        return itemWidth
      }
      if (itemWidth) {
        if (labelWidth) {
          const calcItemWidth = parseInt(labelWidth) + parseInt(inputWidth)
          itemWidth = itemWidth > calcItemWidth ? itemWidth : calcItemWidth
        }
        if (itemWidth && typeof itemWidth === 'string') {
          itemWidth = itemWidth.replace(/[^\d]/g, '')
        }
        if (this.colspan > 1) {
          itemWidth = Number(itemWidth) * this.colspan + 10 * (this.colspan - 1)
        }
        return itemWidth
      } else {
        // if (this.item) {
        // return Number(labelWidth) + Number(this.item.inputWidth);
        // }
        let labelWidth = parseInt(this.item && this.item.labelWidth) || parseInt(this.labelWidth)
        let inputWidth = parseInt(this.item && this.item.inputWidth) || parseInt(this.inputWidth)
        itemWidth = labelWidth + inputWidth
        if (this.colspan > 1) {
          itemWidth = Number(itemWidth) * this.colspan + 10 * (this.colspan - 1)
        }
        return itemWidth
      }
    },
    elSize() {
      if (this.$options.propsData.size === undefined && this.SuiForm) {
        return this.SuiForm.size
      }
      return this.size
    },
    itemRules() {
      if (!this.SuiForm) {
        return null
      }
      let rules = []
      if (this.rules) {
        rules = Array.isArray(this.rules) ? this.rules : [this.rules]
      }
      // 必填的提示信息
      if (
        this.required &&
        !rules.find((obj) => {
          return obj.required === this.required
        })
      ) {
        rules.push({ required: true })
      }
      rules.forEach((r, i) => {
        // 默认触发方式为 blur
        r.trigger = r.trigger || 'blur'
        if (r.required) {
          // 缺省的必填提示信息
          if (getLocalStorage('language') === 'en-US') {
            r.message = r.message || this._locale(this.label + ' ' + '$t[sui.form.required]')
          } else {
            r.message = r.message || this._locale(this.label + '$t[sui.form.required]')
          }
        }
        if (r.valid) {
          // 常用的校验方法
          let arr = r.valid.split(';')
          if (arr.length === 1) {
            r.validator = parserValid(arr[0], (str, obj) => {
              return this._locale(str, obj)
            })
          } else {
            let validArrOther = []
            arr.forEach((v) => {
              validArrOther.push(Object.assign({}, r, { valid: v }))
            })
            validArrOther.forEach((obj) => {
              obj.validator = parserValid(obj.valid, (str, obj) => {
                return this._locale(str, obj)
              })
            })
            rules.splice(i, 1, validArrOther)
          }
        }
      })
      return rules
    },
    itemProp() {
      let { item } = this
      if (!item) {
        return null
      }
      item.events = {}
      // form内组件默认的四个事件。
      ;['blur', 'focus', 'change', 'clear', 'visible-change', 'select-change', 'mounted'].forEach((func) => {
        if (typeof item[func] === 'function') {
          item.events[func] = item[func]
        }
      })

      // 增加默认提示信息
      if (item.placeholder === undefined) {
        this.$set(
          item,
          'placeholder',
          indexOf(['select', 'time', 'date'], this.mold) !== -1
            ? this.$t('sui.form.please.select') + this.label
            : this.$t('sui.form.please.input') + this.label
        )
      } else if (typeof item.placeholder === 'string' && item.placeholder.trim() === '') {
        this.$set(item, 'placeholader', '')
      }
      return item
    },
    item() {
      return this.SuiForm && Array.isArray(this.SuiForm.items)
        ? this.SuiForm.items.find((obj) => {
          return obj.prop === this.prop
        })
        : null
    },
    _mold() {
      // 组件库前缀
      let pre = this.moldPrefix.find((p) => this.mold.startsWith(p))
      return pre ? this.mold : 'sui-' + this.mold
    }
  },
  methods: {
    handlePromptMouseenter(event) {
      this.$refs.tooltip.showTip(event.target)
    },
    handlePromptMouseleave(event) {
      this.$refs.tooltip.hideTip()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/data/SuiFormItem.vue